module.exports = __webpack_public_path__ + "static/media/stearns.b860e3b4.png";